function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ty0 {\n        fill: #6f7b88;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "ty0",
  d: "M4.147,17.87v-3.764c1.561.895,4.146,1.384,6.793,1.452.137-.521.326-1.019.568-1.487-4.854-.013-7.359-1.386-7.359-1.973h-.002v-3.013c1.686.966,4.564,1.466,7.427,1.466s5.738-.499,7.425-1.464v1.111c.52.072,1.021.199,1.5.375v-3.484s.001-.008.001-.012c0-2.281-4.491-3.475-8.926-3.475S2.648,4.795,2.648,7.076c0,.035.011.067.013.102h-.014v10.692c0,2.281,4.49,3.475,8.926,3.475.091,0,.183-.004.274-.005-.3-.467-.545-.971-.733-1.503-4.594-.084-6.967-1.395-6.967-1.967ZM11.574,5.101c4.897,0,7.423,1.383,7.426,1.974h-.001v.007c-.016.593-2.541,1.969-7.425,1.969s-7.426-1.384-7.426-1.975,2.526-1.975,7.426-1.975Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "ty0",
  d: "M19.603,17.105h3.75v-3.75h-1.5v.664c-.94-1.091-2.32-1.769-3.838-1.769-2.798,0-5.074,2.276-5.074,5.074s2.276,5.074,5.074,5.074c1.402,0,2.706-.559,3.672-1.573l-1.086-1.035c-.681.715-1.599,1.108-2.586,1.108-1.971,0-3.574-1.604-3.574-3.574s1.603-3.574,3.574-3.574c1.328,0,2.505.735,3.121,1.854h-1.533v1.5Z"
});

var SvgSimultaneousRestoreSlider = function SvgSimultaneousRestoreSlider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSimultaneousRestoreSlider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/simultaneousRestoreSlider.2c00d7ed.svg";
export { ForwardRef as ReactComponent };